export const FETCH_ORGANISATION_EXPOSED_FUNDS =
  'costAnalysis/FETCH_ORGANISATION_EXPOSED_FUNDS';
export const FETCH_EXPOSED_PENSION_SCHEMES =
  'costAnalysis/FETCH_EXPOSED_PENSION_SCHEMES';
export const FETCH_COST_ANALYSIS = 'costAnalysis/FETCH_COST_ANALYSIS';
export const FETCH_FUND_ANALYSIS = 'costAnalysis/FETCH_FUND_ANALYSIS';
export const FETCH_PAGINATED_FUND_ANALYSIS =
  'costAnalysis/FETCH_PAGINATED_FUND_ANALYSIS';
export const FETCH_PAGINATED_FUNDS = 'costAnalysis/FETCH_PAGINATED_FUNDS';
export const FETCH_CURRENT_FILTERS = 'costAnalysis/FETCH_CURRENT_FILTERS';
export const FETCH_COST_SUMMARY = 'costAnalysis/FETCH_COST_SUMMARY';
export const FETCH_ALL_ASSET_CLASSES = 'costAnalysis/FETCH_ALL_ASSET_CLASSES';
export const FETCH_ALL_ORGANISATIONS = 'costAnalysis/FETCH_ALL_ORGANISATIONS';
export const FETCH_AN_ORGANISATION = 'costAnalysis/FETCH_AN_ORGANISATION';
export const FETCH_ALL_ASSET_MANAGERS = 'costAnalysis/FETCH_ALL_ASSET_MANAGERS';
export const FETCH_ALL_TIME_PERIODS = 'costAnalysis/FETCH_ALL_TIME_PERIODS';
export const FETCH_ALL_ORGANISATION_TYPES =
  'costAnalysis/FETCH_ALL_ORGANISATION_TYPES';
